import type { ReactNode } from 'react';

import { Box } from '@mui/material';

import { DataHubHeader } from '@/features/DataHub/components/DataHubHeader';
import { DataHubSection } from '@/features/DataHub/components/DataHubSection';
import { DATAHUB_SPACING_LG } from '@/features/DataHub/constants/ui';

import { ExportDrawerFooter } from './ExportDrawerFooter';

export const ExportDrawerLayout = ({
  children,
  footer
}: {
  children: ReactNode;
  footer: ReactNode;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-between'
      }}
    >
      <DataHubSection
        scroll
        gap={DATAHUB_SPACING_LG}
        sx={{ p: DATAHUB_SPACING_LG }}
      >
        <DataHubHeader
          subtitle='Set up your export file'
          title='Export configuration'
        />
        {children}
      </DataHubSection>
      <ExportDrawerFooter>{footer}</ExportDrawerFooter>
    </Box>
  );
};
